import poweredByImg from '../../assets/Resources/Images/newPwdBy.png';


const AllPageFooter = ({ pageNumber, propLogo }) => {
  return (
    <div
      className="footer"
      // style={{height:'40mm', margin:'0mm 10mm', position: 'absolute'}}
    >
      <div style={{position: 'absolute', left: '0', right: '0', bottom: '0mm', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <div>
          {/* Render the client property logo when available. */}
          {propLogo ? (
            <img
              src={`data:image/png;base64,${propLogo}`}
              alt="Property logo"
              style={{ height: '60px', width: 'auto' }}
            />
          ) : (
            <div style={{ height: '60px', width: '120px' }} />
          )}
        </div>

        <div style={{textAlign: 'center', color: '#000', fontSize: '15px', fontFamily: 'Arial, sans-serif', width: '120px'}}>
          Page No. {pageNumber}
        </div>

        <div>
          {/* Powered-by branding image shown on every page footer. */}
          <img src={poweredByImg} alt="Powered by" style={{ height: '60px', width: 'auto' }} />
        </div>
      </div>
    </div>
  );
};
export default AllPageFooter;
